import * as React from 'react';
import PropTypes from 'prop-types';

import _ from 'helpers/no_conflict_lodash';

import ContactPreview from '../contact_preview';

class ContactPreviewContainer extends React.Component {
  static propTypes = {
    callId: PropTypes.number,
    callListId: PropTypes.number,
    callListsAccess: PropTypes.bool.isRequired,
    contactId: PropTypes.number,
    contactType: PropTypes.string,
    crmEmail: PropTypes.string,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array,
    displayActions: PropTypes.shape({
      slideClose: PropTypes.string.isRequired
    }).isRequired,
    paths: PropTypes.object.isRequired,
    taskId: PropTypes.number
  };

  constructor(props) {
    super(props);

    this.state = _.pick(props, [
      'callId',
      'callListId',
      'contactId',
      'contactType',
      'taskId'
    ]);
  }

  handleEndCallList = () => {
    this.setState({
      callListId: null,
      taskId: null,
    });

    window[this.props.displayActions.slideClose]();
    sessionStorage.setItem("previewDisplay", false);
  };

  handleCycleCallListTask = (contact, task) => {
    this.setState({
      contactId: contact.associatedModelId,
      contactType: contact.associatedModelType,
      taskId: task.id
    });
  };

  render() {
    return (
      <div className="contact-preview-container">
        <ContactPreview
          {...this.props}
          {...this.state}
          onCycleTask={this.handleCycleCallListTask}
          onEndCallList={this.handleEndCallList}
        />
      </div>
    );
  }
}

export default ContactPreviewContainer;
